/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'
import type { CategoryDetailAdmin } from './CategoryDetailAdmin'
import {
  CategoryDetailAdminFromJSON,
  CategoryDetailAdminFromJSONTyped,
  CategoryDetailAdminToJSON,
} from './CategoryDetailAdmin'

/**
 *
 * @export
 * @interface EnvelopedCategoryCategoryDetailAdmin
 */
export interface EnvelopedCategoryCategoryDetailAdmin {
  /**
   *
   * @type {CategoryDetailAdmin}
   * @memberof EnvelopedCategoryCategoryDetailAdmin
   */
  body: CategoryDetailAdmin
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedCategoryCategoryDetailAdmin
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedCategoryCategoryDetailAdmin interface.
 */
export function instanceOfEnvelopedCategoryCategoryDetailAdmin(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedCategoryCategoryDetailAdminFromJSON(
  json: any,
): EnvelopedCategoryCategoryDetailAdmin {
  return EnvelopedCategoryCategoryDetailAdminFromJSONTyped(json, false)
}

export function EnvelopedCategoryCategoryDetailAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedCategoryCategoryDetailAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: CategoryDetailAdminFromJSON(json['body']),
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedCategoryCategoryDetailAdminToJSON(
  value?: EnvelopedCategoryCategoryDetailAdmin | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: CategoryDetailAdminToJSON(value.body),
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
